import * as yup from "yup";
import {regEx_username} from "../../global";

//RegEx
const passwordRegEx = /^.*(?=.{6,})(?=.*[a-zA-Z])(?=.*\d).*$/;

//schemas
export const loginSchema = yup.object().shape({
  username: yup
    .string()
    .matches(regEx_username)
    .required("Vennligst fyll in mobil/epost"),
  password: yup
    .string()
    .min(6, "Passord for kort")
    .max(60, "Passord for langt")
    .required("Vennligst fyll inn ditt passord")
});
export type loginProps = yup.InferType<typeof loginSchema>;

export const registerSchema = yup.object().shape({
  username: yup
    .string()
    .matches(regEx_username)
    .required("Vennligst fyll in din epost-addresse"),
  password: yup
    .string()
    .matches(passwordRegEx,
      "Ikke gyldig passord, minimum lengde 6, minst 1 nummer & minst en Stor bokstav")
    .required("Vennligst fyll inn passord"),
  name: yup
    .string()
    .required("vennligst fyll inn navn"),
  countryCode: yup
    .number()
    .min(1)
    .max(3)
    .required("Vennligst velg landnummer"),
  mobile: yup
    .string()
    .matches(/^(\+[0-9]{1,3})?[0-9\s]{8,}$/)
    .required("Vennlist fyll inn telefon nummer"),
})
export type registerProps = yup.InferType<typeof registerSchema>;
